import Button from "@material-ui/core/Button";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import { instance } from "Actions/AxiosInstance";
import empty from "Assets/Svg/recruit-no-requistion.svg";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import {
  List,
  TDTypeConsts,
} from "Module/Subscription/business-configration/commons";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import Create from "./create";
import CustomLoader from "Component/CustomLoader";


let shouldCallAPI = true;
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      listdata: [],
      offset: 0,
      limit: 10,
      value: 0,
      data: false,
      selectedRow: null,
      headers: [
        {
          key: "extratimepolicyname",
          name: (
            <FormattedMessage
              id="LbExtraTimeName"
              defaultMessage="Extra Time Name"
            />
          ),
          type: TDTypeConsts.EDIT_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "addedbyimagepath",
          name: (
            <FormattedMessage id="LbCreatedBy" defaultMessage="Created By" />
          ),
          type: TDTypeConsts.CREATED_BY,
        },
        {
          key: "assignedEmployeeList",
          name: (
            <FormattedMessage
              id="LbAssignedEmployee"
              defaultMessage="Assigned Employee"
            />
          ),
          type: TDTypeConsts.ASSIGNED_USER,
          style: { padding: "0" },
        },
        {
          key: "",
          name: (
            <FormattedMessage
              id="LbExtraTimeStatus"
              defaultMessage="Extra Time Status"
            />
          ),
          type: TDTypeConsts.EXTRA_TIME_PAY_STATUS,
        },
      ],
    };

    this.getAllExtraTimePayPolicy = this.getAllExtraTimePayPolicy.bind(this);
    this.renderList = this.renderList.bind(this);
    this.renderCreate = this.renderCreate.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
  }

  componentWillMount() {
    if (this.props.history.location.pathname.includes("create")) {
      this.props.history.push(`${this.props.match.path}/list`);
    }
  }

  handleScroll = () => {
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    if (windowBottom + 50 >= Math.floor(window.innerHeight * 0.65)) {
      if (shouldCallAPI) {
        if (this.state.fullcount > this.state.offset) {
          shouldCallAPI = false;
          this.setState(
            {
              offset: this.state.offset + 10,
            },
            () => this.getAllExtraTimePayPolicy(),
          );
          setTimeout(() => {
            shouldCallAPI = true;
          }, 5000);
        } else {
          this.setState({
            message: "no data",
          });
        }
      }
    }
  };

  componentDidMount() {
    this.getAllExtraTimePayPolicy();
  }

  getAllExtraTimePayPolicy() {
    const { limit = 10, offset = 0 } = { ...this.state };
    this.setState({
      isloading: true
    }, () => {
      instance.get(`/attendance/allextratimepolicybysubid/1/1`).then((resp) => {
        this.setState({
          listdata: resp.data.result,
         // data: true,
          backupList: resp.data.result,
          isloading: false
        });
      });
    })
   
  }

  onCreate() {
    this.props.history.push(`${this.props.match.url}/create`);
  }

  onEdit(row) {
    instance
      .get(`/attendance/extratimepaypolicy/${row.extratimepolicyid}`)
      .then((resp) => {
        const postData = (resp.data.result && resp.data.result[0]) || [];
        postData.extratime &&
          postData.extratime.forEach((objExtraTime) => {
            objExtraTime.overtimeconfig &&
              objExtraTime.overtimeconfig.forEach((objOverTime) => {
                objOverTime.formulaarray = JSON.parse(objOverTime.formulaarray);
              });
          });

        this.setState({ postData }, () => {
          this.props.history.push(`${this.props.match.url}/create`);
        });

        this.setState({
          postData: null,
          createmenu: false,
          create_anchorEl: null,
        });
      });
  }

  onDelete() {
    const { selectedRow } = this.state;
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            instance
              .get(`recruit/deletehiringplan/${selectedRow.hiringplanid}`)
              .then(
                () => {
                  this.props.enqueueSnackbar("Deleted successfully", {
                    variant: "success",
                  });
                  this.props.closeSnackbar();
                  this.setState(
                    {
                      backupList: [],
                      totalcount: 1,
                    //  data: [],
                      offset: 0,
                      createmenu: false,
                    },
                    () => {
                      this.getAllHiringPlan();
                    },
                  );
                },
                (error) => {
                  const CommonError = error.response
                    ? error.response.data.error.message
                    : error.message;
                  this.props.enqueueSnackbar(CommonError, { variant: "error" });
                  this.props.closeSnackbar();
                },
              );
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  renderCreate() {
    return (
      <Create
        {...this.props}
        {...this.state}
        onCreate={true}
        updatePostData={this.updatePostData}
        getAllExtraTimePayPolicy={() => this.getAllExtraTimePayPolicy()}
      />
    );
  }

  renderList() {
    return (
      <div className="content-outer-wrapper">
        {this.state.isloading ?
          <div> <CustomLoader /></div>
          : <div>
            {this.state.listdata && this.state.listdata.length > 0 ? (
              <div>
                <List
                  list={this.state.listdata}
                  permissions={this.state.permissions}
                  headers={this.state.headers}
                  onCreate={this.onCreate}
                  onVersionChange={this.onVersionChange}
                  onEdit={this.onEdit}
                  onDelete={this.onDelete}
                  onMoreOptionClick={(e, row) => this.onMoreOptionClick(e, row)}
                  module="Extra time Policie"
                />
                <Popover
                  open={this.state.createmenu}
                  anchorEl={this.state.create_anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  onClose={() => this.setState({ createmenu: false })}
                  className="margin-top-8"
                >
                  <Paper style={{ width: 190 }}>
                    <div>
                      <MenuListComponent>
                        <ListItem
                          className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                          onClick={this.onEdit}
                        >
                          <ListItemText style={{ padding: 0 }}>
                            <span className="small-dark-secondary">Edit</span>
                          </ListItemText>
                        </ListItem>
                      </MenuListComponent>
                    </div>
                  </Paper>
                </Popover>
              </div>
            ) : (
              <div className="position-rel">
                <DefaultComp
                  heading="There are no extra time pay policies to display"
                  subheading="Get started by creating your first policy!"
                  imageSrc={empty}
                />
                {this.state.permissions.editable && (
                  <div className="text-center margin-top-24">
                    <Button
                      className="btn btn-primary-md-blue"
                      variant="contained"
                      onClick={this.onCreate}
                    >
                      Create new
                    </Button>
                  </div>
                )}
              </div>
            )}
          </div>
        }
      </div>
    );
  }

  render() {
    const { match } = this.props;
    return (
      <div>
        <IntlProvider locale="en">
          <div>
           
              <div>
                <div>
                  <Switch>
                    <Route
                      exact
                      path={`${match.path}`}
                      render={this.renderList}
                    />
                    <Route
                      exact
                      path={`${match.path}/create`}
                      render={this.renderCreate}
                    />
                    <Redirect from={`${match.path}`} to={`${match.path}`} />
                  </Switch>
                </div>
              </div>
           
          </div>
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = () => { };

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(index)),
);
